export const AccessControlIcon2 = () => {
  return (
    <svg
      width="160"
      height="138"
      viewBox="0 0 160 138"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="8.61169"
        y="21.6302"
        width="70.4788"
        height="69.3234"
        rx="17.9086"
        transform="rotate(6.3364 8.61169 21.6302)"
        fill="#A0BAB6"
      />
      <g filter="url(#filter0_f_1021_16495)">
        <path
          d="M124.61 47.3679C124.13 45.8022 122.291 40.0335 117.828 36.7225C115.611 35.1131 113.155 34.3376 110.682 34.4664C102.954 34.6266 97.6845 42.8474 96.4607 44.8577C95.2388 42.8474 89.9679 34.6404 82.2399 34.4664C79.7665 34.3376 77.3103 35.1131 75.0936 36.7225C70.6309 40.0363 68.7914 45.8022 68.3118 47.3679C67.37 50.4973 66.9103 53.8911 66.9652 57.3091C66.9652 58.5131 67.0351 63.4257 69.1503 69.8572C71.3127 76.4349 74.3703 80.4059 76.4571 83.3883C81.5589 90.6341 87.2577 96.9413 93.3808 102.223C95.2822 103.863 97.6393 103.863 99.5407 102.223C105.664 96.9413 111.363 90.6341 116.464 83.3883C118.542 80.4114 121.609 76.4405 123.773 69.8572C125.886 63.4257 125.954 58.5131 125.956 57.3091C126.012 53.891 125.552 50.4968 124.61 47.3679Z"
          fill="url(#paint0_linear_1021_16495)"
        />
      </g>
      <g filter="url(#filter1_bi_1021_16495)">
        <rect
          x="39.035"
          width="65.3298"
          height="128.94"
          rx="17.1921"
          fill="#FDFDFD"
          fill-opacity="0.59"
        />
        <rect
          x="39.435"
          y="0.4"
          width="64.5298"
          height="128.14"
          rx="16.7921"
          stroke="white"
          strokeWidth="0.8"
        />
      </g>
      <g opacity="0.8">
        <circle
          cx="71.6999"
          cy="114.328"
          r="6.87683"
          fill="url(#paint1_linear_1021_16495)"
        />
        <circle
          cx="71.6999"
          cy="114.328"
          r="6.87683"
          fill="black"
          fill-opacity="0.1"
        />
      </g>
      <g filter="url(#filter2_bi_1021_16495)">
        <rect
          x="58.9608"
          y="24.4527"
          width="72.481"
          height="73.8572"
          rx="14.59"
          fill="white"
          fill-opacity="0.5"
        />
        <rect
          x="59.3739"
          y="24.8658"
          width="71.6548"
          height="73.031"
          rx="14.1769"
          stroke="url(#paint2_linear_1021_16495)"
          stroke-opacity="0.5"
          strokeWidth="0.826168"
        />
      </g>
      <path
        d="M113.031 75.3699C113.031 72.9361 112.551 70.5261 111.62 68.2775C110.688 66.0289 109.323 63.9858 107.602 62.2648C105.881 60.5438 103.838 59.1787 101.59 58.2473C99.3411 57.3159 96.9311 56.8365 94.4972 56.8365C92.0634 56.8365 89.6533 57.3159 87.4048 58.2473C85.1562 59.1787 83.1131 60.5438 81.3921 62.2648C79.6711 63.9858 78.3059 66.0289 77.3745 68.2775C76.4431 70.5261 75.9637 72.9361 75.9637 75.3699L94.4972 75.3699H113.031Z"
        fill="url(#paint3_linear_1021_16495)"
      />
      <path
        d="M113.031 75.3699C113.031 72.9361 112.551 70.5261 111.62 68.2775C110.688 66.0289 109.323 63.9858 107.602 62.2648C105.881 60.5438 103.838 59.1787 101.59 58.2473C99.3411 57.3159 96.9311 56.8365 94.4972 56.8365C92.0634 56.8365 89.6533 57.3159 87.4048 58.2473C85.1562 59.1787 83.1131 60.5438 81.3921 62.2648C79.6711 63.9858 78.3059 66.0289 77.3745 68.2775C76.4431 70.5261 75.9637 72.9361 75.9637 75.3699L94.4972 75.3699H113.031Z"
        fill="black"
        fill-opacity="0.1"
      />
      <circle cx="94.4971" cy="50.6594" r="12.3556" fill="#619D94" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.473 59.1536C101.221 61.5318 98.0339 63.0152 94.5002 63.0152C90.9663 63.0152 87.779 61.5316 85.527 59.1534C86.135 58.8169 86.7627 58.5143 87.4073 58.2473C89.6559 57.3159 92.0659 56.8365 94.4998 56.8365C96.9336 56.8365 99.3436 57.3159 101.592 58.2473C102.237 58.5143 102.865 58.8171 103.473 59.1536Z"
        fill="url(#paint4_linear_1021_16495)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.473 59.1536C101.221 61.5318 98.0339 63.0152 94.5002 63.0152C90.9663 63.0152 87.779 61.5316 85.527 59.1534C86.135 58.8169 86.7627 58.5143 87.4073 58.2473C89.6559 57.3159 92.0659 56.8365 94.4998 56.8365C96.9336 56.8365 99.3436 57.3159 101.592 58.2473C102.237 58.5143 102.865 58.8171 103.473 59.1536Z"
        fill="black"
        fill-opacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.6926 43.6749C34.7604 43.0334 34.2953 42.4584 33.6538 42.3906L23.684 41.3363C23.4167 41.308 23.177 41.5018 23.1488 41.7691L23.0976 42.2531C23.0976 42.2531 23.0976 42.2532 23.0975 42.2532C23.0975 42.2532 23.0975 42.2532 23.0975 42.2532L21.992 52.707C21.9242 53.3485 22.3892 53.9236 23.0307 53.9914L25.3538 54.2371C25.9953 54.3049 26.5703 53.8399 26.6382 53.1984L27.2319 47.5841C27.2997 46.9426 27.8747 46.4776 28.5162 46.5454L33.1625 47.0367C33.804 47.1046 34.3791 46.6395 34.4469 45.998L34.6926 43.6749Z"
        fill="url(#paint5_linear_1021_16495)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.356 75.23C31.2881 75.8715 30.7131 76.3365 30.0716 76.2687L20.102 75.2144C19.8345 75.1862 19.6407 74.9464 19.6689 74.679L19.7201 74.1949C19.7201 74.1948 19.7201 74.1947 19.7199 74.1947C19.7198 74.1947 19.7197 74.1946 19.7198 74.1945L20.8252 63.7408C20.893 63.0993 21.4681 62.6342 22.1096 62.7021L24.4327 62.9477C25.0742 63.0156 25.5392 63.5906 25.4714 64.2321L24.8776 69.8468C24.8098 70.4883 25.2748 71.0633 25.9163 71.1312L30.5629 71.6225C31.2044 71.6904 31.6695 72.2654 31.6016 72.9069L31.356 75.23Z"
        fill="url(#paint6_linear_1021_16495)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.5338 44.8214C45.6017 44.1799 46.1767 43.7149 46.8182 43.7827L56.1106 44.7654C56.7521 44.8332 57.2171 45.4082 57.1493 46.0497L56.7808 49.5343C56.7808 49.5343 56.7807 49.5343 56.7807 49.5343C56.7806 49.5343 56.7806 49.5344 56.7806 49.5344L56.0641 56.3101C55.9962 56.9516 55.4212 57.4167 54.7797 57.3488L52.4566 57.1032C51.8151 57.0353 51.3501 56.4603 51.4179 55.8188L52.0116 50.2046C52.0794 49.5631 51.6144 48.988 50.9729 48.9202L46.3269 48.4289C45.6854 48.3611 45.2203 47.786 45.2882 47.1445L45.5338 44.8214Z"
        fill="url(#paint7_linear_1021_16495)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.1966 76.3764C42.1288 77.0179 42.5938 77.593 43.2353 77.6608L52.5277 78.6435C53.1692 78.7113 53.7442 78.2462 53.812 77.6047L54.1805 74.1201C54.1805 74.1201 54.1805 74.1201 54.1805 74.1201C54.1805 74.1201 54.1805 74.1201 54.1805 74.1201L54.8969 67.3445C54.9648 66.703 54.4997 66.128 53.8582 66.0601L51.5352 65.8145C50.8936 65.7466 50.3186 66.2117 50.2508 66.8532L49.6571 72.4672C49.5893 73.1087 49.0142 73.5738 48.3727 73.506L43.7266 73.0146C43.0851 72.9468 42.5101 73.4119 42.4423 74.0534L42.1966 76.3764Z"
        fill="url(#paint8_linear_1021_16495)"
      />
      <defs>
        <filter
          id="filter0_f_1021_16495"
          x="32.9608"
          y="0.452637"
          width="127"
          height="137"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="17"
            result="effect1_foregroundBlur_1021_16495"
          />
        </filter>
        <filter
          id="filter1_bi_1021_16495"
          x="-4.96497"
          y="-44"
          width="153.33"
          height="216.94"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="22" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1021_16495"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1021_16495"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="13.5" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1021_16495"
          />
        </filter>
        <filter
          id="filter2_bi_1021_16495"
          x="40.6112"
          y="6.10308"
          width="109.18"
          height="110.556"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="9.17481" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_1021_16495"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_1021_16495"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="-4.5874" dy="4.5874" />
          <feGaussianBlur stdDeviation="4.5874" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1021_16495"
          />
        </filter>
        <linearGradient
          id="paint0_linear_1021_16495"
          x1="120.771"
          y1="39.8683"
          x2="71.1993"
          y2="73.9753"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#A1B5B1" />
          <stop offset="1" stopColor="#3E5854" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1021_16495"
          x1="67.6489"
          y1="107.451"
          x2="80.2063"
          y2="121.519"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stop-opacity="0" />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_1021_16495"
          x1="58.9608"
          y1="24.4527"
          x2="115.615"
          y2="81.1071"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stop-opacity="0.5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_1021_16495"
          x1="83.5794"
          y1="56.8365"
          x2="96.2559"
          y2="85.2407"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stop-opacity="0" />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_1021_16495"
          x1="89.2141"
          y1="56.8365"
          x2="92.4025"
          y2="67.2119"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stop-opacity="0" />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_1021_16495"
          x1="25.5864"
          y1="41.5375"
          x2="35.8791"
          y2="54.7114"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stop-opacity="0" />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_1021_16495"
          x1="22.0039"
          y1="75.4156"
          x2="34.8249"
          y2="64.6858"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stop-opacity="0" />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_1021_16495"
          x1="54.8856"
          y1="44.6358"
          x2="42.0652"
          y2="55.3652"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stop-opacity="0" />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_1021_16495"
          x1="51.3027"
          y1="78.5139"
          x2="41.01"
          y2="65.3404"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#026051" />
          <stop offset="1" stopColor="#3B5F59" stop-opacity="0" />
          <stop offset="1" stopColor="#47A092" />
        </linearGradient>
      </defs>
    </svg>
  );
};
